import Tanakayuhome1 from '../../Media/homeimages/Tanakayu Vasya.webp'
import Tanakayuhome2 from '../../Media/homeimages/Tanakayu Vasya.webp'





const Tanakayuhomeimages =[
Tanakayuhome1,Tanakayuhome2
]

export default Tanakayuhomeimages;